module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', {
    staticClass: "user-list__user__table__tbody"
  }, _vm._l((_vm.events), function(event) {
    return _c('tr', {
      key: event.event_id,
      staticClass: "user-list__user__table__event",
      class: {
        'user-list__user__table__event--special': event.v_is_special
      }
    }, [_c('td', [_vm._v(_vm._s(event.v_start_and_endtime) + " | "), (event.v_is_special) ? _c('span', {
      staticClass: "d-tag"
    }, [_vm._v(_vm._s(event.title))]) : _c('b', [_vm._v(_vm._s(event.title))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(event.v_calendar_name))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "d-tag"
    }, [_vm._v(_vm._s(event.v_event_type_name))])]), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(event.v_substitute_for_name) + "\n    "), (event.v_substitute_for_employments.length > 0) ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return event.v_substitute_for_employments.length > 1; }
        }),
        expression: "{\n                          arrow: true,\n                          animateFill: false,\n                          animation : 'shift-away',\n                          zIndex: '999999992',\n                          boundary: 'window',\n                          onShow: () => event.v_substitute_for_employments.length > 1\n                        }"
      }],
      staticClass: "d-tag",
      attrs: {
        "content": event.v_substitute_for_employments
      }
    }, [_vm._v("\n                    " + _vm._s(event.v_substitute_for_employments[0]) + "\n                    "), (event.v_substitute_for_employments.length > 1) ? [_vm._v("m.fl.")] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.userDay.state === 'draft') ? [(_vm.user.v_user_active_employments.length < 1) ? _c('p', {
      staticClass: "text-explainer"
    }, [_vm._v("Ingen ansættelser")]) : _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (event.employment_id),
        expression: "event.employment_id",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "no-print",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return _vm._n(val)
          });
          _vm.$set(event, "employment_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updatePropOnLesson('employment_id', _vm.user, _vm.userDay, event, $event.target.value)
        }]
      }
    }, _vm._l((_vm.user.v_user_active_employments), function(userEmployment) {
      return _c('option', {
        domProps: {
          "value": Number(userEmployment.id)
        }
      }, [_vm._v("\n          " + _vm._s(userEmployment.title) + "\n        ")])
    }), 0), _vm._v(" "), _c('span', {
      staticClass: "only-print",
      class: {
        'italic': event.v_employment_id_title === 'Ingen valgt'
      }
    }, [_vm._v("\n        " + _vm._s(event.v_employment_id_title) + "\n      ")])] : _c('span', {
      class: {
        'd-tag': event.v_employment_id_title && event.v_employment_id_title !== 'Ingen valgt'
      }
    }, [_vm._v(_vm._s(event.v_employment_id_title) + "\n    ")])], 2), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('td', {
      staticClass: "td-salary-input-number"
    }, [(_vm.userDay.state === 'draft') ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (event.loenart),
        expression: "event.loenart"
      }],
      staticClass: "no-print do-input",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (event.loenart)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(event, "loenart", $event.target.value)
        }, function($event) {
          return _vm.updatePropOnLesson('loenart', _vm.user, _vm.userDay, event, $event.target.value)
        }]
      }
    })] : [_vm._v("\n      " + _vm._s(event.loenart) + "\n    ")]], 2) : _vm._e(), _vm._v(" "), (_vm.isSalaryIntegrationActive) ? _c('td', {
      staticClass: "td-salary-input-number"
    }, [(_vm.userDay.state === 'draft') ? [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (event.loebenummer),
        expression: "event.loebenummer"
      }],
      staticClass: "no-print do-input input-loebenummer",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (event.loebenummer)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(event, "loebenummer", $event.target.value)
        }, function($event) {
          return _vm.validateLoebenummer(_vm.user, _vm.userDay, event, $event.target.value)
        }]
      }
    })] : [_vm._v("\n      " + _vm._s(event.loebenummer) + "\n    ")]], 2) : _vm._e(), _vm._v(" "), (_vm.isSalaryIntegrationActive && _vm.costCenters.length > 0) ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (event.afv_omkostningssted),
        expression: "event.afv_omkostningssted",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "no-print",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return _vm._n(val)
          });
          _vm.$set(event, "afv_omkostningssted", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updatePropOnLesson('afv_omkostningssted', _vm.user, _vm.userDay, event, $event.target.value)
        }]
      }
    }, _vm._l((_vm.costCenters), function(costCenter) {
      return _c('option', {
        domProps: {
          "value": Number(costCenter.code)
        }
      }, [_vm._v("\n        " + _vm._s(costCenter.title) + "\n      ")])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n    " + _vm._s(event.minutes) + " min.\n  ")])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-57b76e06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySubsPerfUserDay.vue
// module id = 1611
// module chunks = 1